
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ChartData, ChartOptions } from 'chart.js';
import { Doughnut } from 'vue-chartjs';
import { renderChart } from '@/features/common/types';

@Component({
  extends: Doughnut,
})
export default class DoughnutChart extends Vue {
  @Prop({ required: true, type: Object }) data!: ChartData;

  private options: ChartOptions = {
    legend: {
      display: false,
    },
    cutoutPercentage: 77,
    tooltips: {
      enabled: false,
    },
  };

  private renderChart!: renderChart;

  mounted(): void {
    this.renderChart(this.data, this.options);
  }
}
